import {match} from 'ts-pattern';

import {SubscribeToNotificationsApiArg} from '@dms/api/appsync';
import {notificationTypes} from '@dms/shared';

export function getPhotoCheckerNotificationAlbumId(
  notification: SubscribeToNotificationsApiArg
): string | undefined {
  return match(notification)
    .with(
      {
        type: notificationTypes.SALE_VEHICLE_PHOTO_CHECKER_REPORT_PROCESSING,
        variant: 'background',
      },
      (n) => n.payload.saleVehicleAlbumId
    )
    .with(
      {type: notificationTypes.SALE_VEHICLE_PHOTO_CHECKER_REPORT_FAILED},
      (n) => n.payload.saleVehicleAlbumId
    )
    .with(
      {type: notificationTypes.SALE_VEHICLE_PHOTO_CHECKER_REPORT_LOW_SCORE},
      (n) => n.payload.saleVehicleAlbumId
    )
    .otherwise(() => undefined);
}
